import { Component, Inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DeaktivirajOJCommand, DeaktivirajOrganizacioniEntitetCommand, DeaktivirajTeritorijalnuNadleznostCommand, KatalogInstitucijaClient, TeritorijalneNadleznostiClient } from 'app/api/iop-katalog-institucija-api-reference';
import { DeaktivirajSadrzajSluzbeneEvidencijeCommand, DeaktivirajSluzbenuEvidencijuCommand, GenericActionResponseSE, SluzbenaEvidencijaClient } from 'app/api/iop-metaregistar-api-reference';
import { GenericConfirmComponent } from 'app/shared/services/generic-confirm/generic-confirm.component';
import moment from 'moment';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  };
}

@Component({
  selector: 'app-deaktivacija-popup',
  templateUrl: './deaktivacija-popup.component.html',
  styleUrls: ['./deaktivacija-popup.component.scss']
})
export class DeaktivacijaPopupComponent implements OnInit {
  translatePrefix: string = "features.sluzbenaEvidencija.osnovniPodaci.";
  errorPrefix: string = "errors.";
  successPrefix: string = "successes.";

  deaktivacijaSE: boolean = false;
  deaktivacijaSadrzaja: boolean = false;

  constructor(private fb: FormBuilder,
    private matSnack: MatSnackBar,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<DeaktivacijaPopupComponent>,
    private seService: SluzbenaEvidencijaClient,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, podaci: any }) {
  }

  unos: FormGroup;
  minDate: any;

  ngOnInit(): void {
    this.buildForm()
  }

  buildForm() {
    let danasnjiDatum = new Date();
    this.minDate = new Date(this.data.podaci.datumOd);
    if (moment(this.minDate).startOf("day") < moment(danasnjiDatum).startOf("day")) this.minDate = danasnjiDatum;

    this.minDate.setDate(this.minDate.getDate() + 1);

    this.unos = this.fb.group({
      datumDeaktiviranja: new FormControl<any>(this.minDate, [Validators.required]),
      razlogDeaktivacije: new FormControl<string>(null, [Validators.required, noWhitespaceValidator()])
    })

    if (this.data.podaci.sifra) {
      this.deaktivacijaSE = true;
    } else {
      this.deaktivacijaSadrzaja = true;
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm(event: any) {
    if (this.unos.invalid) return;
    if (this.deaktivacijaSE) {
      this.deaktivirajSE();
    } else {
      this.deaktivirajSadrzaj();
    }

  }

  deaktivirajSE() {
    this.seService.deaktivirajSluzbenuEvidenciju(new DeaktivirajSluzbenuEvidencijuCommand({
      sifra: this.data.podaci.sifra,
      datumDeaktivacije: this.datumDeaktiviranja.value,
      razlogDeaktivacije: this.razlogDeaktivacije.value,
      potvrdaBrisanjaVerzijeUPripremi: false
    })).pipe(
      switchMap(res => {
        if (res.responseBool) {
          return of(res);
        }
        else if (!res.responseBool && res.responseMessage === "EVIDENCIJA_IMA_VERZIJU_U_PRIPREMI") {
          return this.potvrdaDeaktivacijeSESaBrisanjemVerzijeUPripremi();
        }
        else {
          return EMPTY;
        }
      })
    ).subscribe(res => {
      if (res.responseBool) {
        this.matSnack.open(this.translate.instant(this.successPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'successSnack' });
        this.dialogRef.close(true);
      } else {
        this.matSnack.open(this.translate.instant(this.errorPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'errorSnack' });
        this.dialogRef.close(false);
      }
    })
  }

  potvrdaDeaktivacijeSESaBrisanjemVerzijeUPripremi(): Observable<GenericActionResponseSE> {
    return this.dialog.open(GenericConfirmComponent, {
      data: {
        title: this.translatePrefix + 'postojiVerzijaSEUPripremi',
        message: this.translatePrefix + 'daLiZeliteDaObriseteVerzijuSEUPripremi'
      }
    }).afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.seService.deaktivirajSluzbenuEvidenciju(new DeaktivirajSluzbenuEvidencijuCommand({
            sifra: this.data.podaci.sifra,
            datumDeaktivacije: this.datumDeaktiviranja.value,
            razlogDeaktivacije: this.razlogDeaktivacije.value,
            potvrdaBrisanjaVerzijeUPripremi: true
          }));
        }
        else {
          return EMPTY;
        }
      })
    );
  }

  deaktivirajSadrzaj() {
    this.seService.deaktivirajSadrzaj(new DeaktivirajSadrzajSluzbeneEvidencijeCommand({
      sifra: this.data.podaci.sifraSadrzaja,
      datumDo: this.datumDeaktiviranja.value,
      razlogDeaktivacije: this.razlogDeaktivacije.value,
      potvrdaBrisanjaVerzijeUPripremi: false
    })).pipe(
      switchMap(res => {
        if (!res.responseBool && (res.responseMessage === "EVIDENCIJA_IMA_VERZIJU_U_PRIPREMI")) {
          return this.potvrdaDeaktivacijeSadrzajaSaBrisanjemVerzijeSEUPripremi();
        }
        else {
          return of(res);
        }
      })
    ).subscribe(res => {
      if (res.responseBool) {
        this.matSnack.open(this.translate.instant(this.successPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'successSnack' });
        this.dialogRef.close(true);
      } else {
        this.matSnack.open(this.translate.instant(this.errorPrefix + res.responseMessage), null, { duration: 5000, panelClass: 'errorSnack' });
        this.dialogRef.close(false);
      }
    })
  }

  potvrdaDeaktivacijeSadrzajaSaBrisanjemVerzijeSEUPripremi(): Observable<GenericActionResponseSE> {
    return this.dialog.open(GenericConfirmComponent, {
      data: {
        title: this.translatePrefix + 'postojiVerzijaSEUPripremi',
        message: this.translatePrefix + 'daLiZeliteDaObriseteVerzijuSEUPripremi'
      }
    }).afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.seService.deaktivirajSadrzaj(new DeaktivirajSadrzajSluzbeneEvidencijeCommand({
            sifra: this.data.podaci.sifraSadrzaja,
            datumDo: this.datumDeaktiviranja.value,
            razlogDeaktivacije: this.razlogDeaktivacije.value,
            potvrdaBrisanjaVerzijeUPripremi: true
          }));
        }
        else {
          return EMPTY;
        }
      })
    );
  }

  get datumDeaktiviranja() {
    return this.unos.get('datumDeaktiviranja');
  }
  get razlogDeaktivacije() {
    return this.unos.get('razlogDeaktivacije');
  }

}
